<template>
  <el-dialog
    :title="this.$t('receivablesManageDialog.title.secondClaimTitle')"
    :visible.sync="dialogVisible"
    width="80%"
    class="secondClaimDialog"
    id="secondClaimDialog"
    @close="closeDialog"
  >
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <!-- 表格 -->
    <div class="main-content">
      <vxe-grid
        border
        show-overflow
        resizable
        ref="table"
        class="vxe-table-element"
        size="mini"
        align="left"
        column-min-width="120"
        :loading="load"
        :auto-resize="true"
        :data="tableData"
        :max-height="tableHeight"
        :columns="columnList"
        :toolbar="{ custom: true }"
        :custom-config="{ storage: true }"
        :edit-rules="rules"
        :edit-config="isEdit ? { trigger: 'click', mode: 'row' } : ''"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        show-footer
        :footer-method="footerMethod"
      >
      </vxe-grid>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{
        this.$t('receivablesManageList.button.cancel')
      }}</el-button>
      <el-button :disabled="!isEdit" type="primary" @click="save">{{
        this.$t('receivablesManageList.button.determine')
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
  import SiruiSearch from '@/components/SiruiSearch';
  // import inputNumberAd from '@/components/form-item/input-number-advance';
  import API from '@/api/capitalCenter/receivablesManage';
  export default {
    props: ['departmentList'],
    data() {
      return {
        tableHeight: document.body.clientHeight - 400 + 'px' || 0,
        dialogVisible: false,
        load: false,
        tableData: [],
        currency: null,
        sumObj: {},
        query: {
          isHNFlag: null,
          businessType: null,
          registerId: null,
          firstClaimId: null,
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          contractCreateDate: null,
          customerNo: null,
          customerName: null,
          receivedType: null,
          contractCategory: null,
          isCreditsale: null,
          ladingNo: null,
          contractNo: null,
        },
        rowObj: {
          registerId: null,
          receivedType: null,
          contractBusinessDepartment: null,
          contractBusinessDepartmentName: null,
          contractNo: null,
          isCreditsale: '0', // 是否赊销
          contractTotalAmount: 0, // 合同金额
          contractCreateDate: null, // 合同创建日期
          contractMarginAmount: 0, // 合同保证金金额
          receiveMarginAmount: 0, // 已认领保证金金额
          receiveGoodsAmount: 0, // 已认领货款金额
          originReceiveMarginAmount: 0, // 认领保证金金额
          originReceiveGoodsAmount: 0, // 认领货款金额
          claimedAmount: 0, // 已认领金额(保证金+货款)
          unClaimedAmount: 0, // 未认领金额(合同金额-已认领金额)
          originProformaInvoiceAmount: 0,
          originReceiveMoneyAmount: 0,
          originDomesticBankDeductFee: 0,
          originForeignBankDeductFee: 0,
        },
        flagUnClaimedAmount: 0,
        secondUnClaimAmount: {},
        secondTotalAmount: {},
        receivedTypeOptions: [],
      };
    },
    components: {
      SiruiSearch,
      // inputNumberAd,
    },
    computed: {
      searchColumns() {
        return [
          {
            // 部门
            name: this.$t('receivablesManageDialog.secondClaim.contractBusinessDepartment'),
            prop: 'contractBusinessDepartmentName',
            type: 'input',
            disabled: true,
          },
          {
            // 收款类别
            name: this.$t('receivablesManageDialog.secondClaim.receivedType'),
            prop: 'receivedType',
            type: 'select',
            options: this.receivedTypeOptions,
            disabled: true,
          },
          {
            // 是否赊销
            name: this.$t('receivablesManageDialog.secondClaim.isCreditsale'),
            prop: 'isCreditsale',
            type: 'dict',
            dictType: 'yes-no',
          },
          {
            // 合同创建日期
            name: this.$t('receivablesManageDialog.secondClaim.contractCreateDate'),
            prop: 'contractCreateDate',
            type: 'date',
          },
          {
            // 客户
            name: this.$t('receivablesManageDialog.secondClaim.customerNo'),
            prop: 'customerName',
            type: 'input',
            disabled: true,
          },
          {
            //销售合同号
            prop: 'contractNo',
            name: '销售合同号',
            type: 'input',
            placeholder: '请选择销售合同号',
          },
        ];
      },
      //基础数据表单配置
      columnList() {
        return [
          { type: 'checkbox', width: 50, fixed: 'left' },
          {
            // 序号
            type: 'seq',
            width: 90,
            title: this.$t('receivablesManage.receivablesClaimInfo.seq'),
            fixed: 'left',
          },
          {
            // 销售合同管理号
            field: 'contractNo',
            title: this.$t('receivablesManageDialog.secondClaim.salesContractNo'),
          },
          {
            // 是否赊销
            field: 'isCreditsale',
            title: this.$t('receivablesManageDialog.secondClaim.isCreditsale'),
            editRender: {
              name: 'ElSelect',
              options: this.$baseRequest.getDictListMapByType('yes-no'),
              props: {
                clearable: true,
                filterable: true,
                disabled: true,
              },
            },
            dictType: 'yes-no',
          },
          {
            // 合同金额
            field: 'contractTotalAmount',
            title:
              this.$t('receivablesManageDialog.secondClaim.contractTotalAmount') +
              '(' +
              this.currency +
              ')',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.contractTotalAmount)}</span>,
                ];
              },
            },
          },
          {
            // 合同创建日期
            field: 'contractCreateDate',
            title: this.$t('receivablesManageDialog.secondClaim.contractCreateDate'),
          },
          {
            // 签单日期
            field: 'signDate',
            title: '签单日期',
          },
          {
            // 合同保证金金额
            field: 'contractMarginAmount',
            title: '合同保证金金额',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.contractMarginAmount)}</span>,
                ];
              },
            },
          },
          {
            // 已认领保证金金额
            field: 'receiveMarginAmount',
            title: '已认领合同保证金金额',
            width: 150,
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.receiveMarginAmount)}</span>,
                ];
              },
            },
          },
          {
            // 已认领货款金额
            field: 'receiveGoodsAmount',
            title: '已认领货款金额',
            width: 150,
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.receiveGoodsAmount)}</span>];
              },
            },
          },
          {
            // 认领保证金金额
            field: 'originReceiveMarginAmount',
            title: '本次认领保证金金额',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMarginAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveMarginAmount}
                    max={999999999.999999}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveMarginAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 认领货款金额
            field: 'originReceiveGoodsAmount',
            title: '本次认领货款金额',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveGoodsAmount)}</span>,
                ];
              },
              edit: ({ row }) => {
                return [
                  <input-number-ad
                    value={row.originReceiveGoodsAmount}
                    max={999999999.999999}
                    min={0}
                    onInput={(val) => this.chooseTable(val, row, 'originReceiveGoodsAmount')}
                  ></input-number-ad>,
                ];
              },
            },
          },
          {
            // 已认领金额(保证金+货款)
            field: 'claimedAmountTemp',
            title: '已认领金额(保证金+货款)',
            slots: {
              default: ({ row }) => {
                return [<span>{this.$baseRequest.formatTableColumn(row.claimedAmountTemp)}</span>];
              },
            },
          },
          {
            // 未认领金额(合同金额-已认领金额)
            field: 'unClaimedAmountTemp',
            title: '未认领金额(合同金额-已认领金额)',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.unClaimedAmountTemp)}</span>,
                ];
              },
            },
          },
          /* { // 已认领金额(保证金+货款)
          field: 'claimedAmount',
          title: '已认领金额(保证金+货款)',
          slots: {
            default: ({ row }) => {
              return [
                <span>{ this.$baseRequest.formatTableColumn(row.claimedAmount) }</span>
              ]
            }
          }
        },
        { // 未认领金额(合同金额-已认领金额)
          field: 'unClaimedAmount',
          title: '未认领金额(合同金额-已认领金额)',
          slots: {
            default: ({ row }) => {
              return [
                <span>{ this.$baseRequest.formatTableColumn(row.unClaimedAmount) }</span>
              ]
            }
          }
        }, */
          /* { // 形式发票金额
          field: "originProformaInvoiceAmount",
          title: this.$t('receivablesManage.receivablesClaimInfo.originProformaInvoiceAmount')+'('+this.currency+')',
          slots: {
            default: ({ row }) => {
              return [
                <span>{ this.$baseRequest.formatTableColumn(row.originProformaInvoiceAmount) }</span>
              ]
            }
          }
        }, */
          {
            // 收款金额
            field: 'originReceiveMoneyAmount',
            title:
              this.$t('receivablesManage.receivablesClaimInfo.originReceiveMoneyAmount') +
              '(' +
              this.currency +
              ')',
            slots: {
              default: ({ row }) => {
                return [
                  <span>{this.$baseRequest.formatTableColumn(row.originReceiveMoneyAmount)}</span>,
                ];
              },
            },
          },
          /* { // 国内银行扣费
          field: "originDomesticBankDeductFee",
          title: this.$t('receivablesManage.receivablesClaimInfo.originDomesticBankDeductFee')+'('+this.currency+')',
          slots: {
            default: ({ row }) => {
              return [
                <span>{ this.$baseRequest.formatTableColumn(row.originDomesticBankDeductFee) }</span>
              ]
            }
          }
        },
        { // 国外银行扣费
          field: "originForeignBankDeductFee",
          title: this.$t('receivablesManage.receivablesClaimInfo.originForeignBankDeductFee')+'('+this.currency+')',
          slots: {
            default: ({ row }) => {
              return [
                <span>{ this.$baseRequest.formatTableColumn(row.originForeignBankDeductFee) }</span>
              ]
            }
          }
        }, */
        ];
      },
      // 原币基准值名称(当一次认领存在形式发票金额时，以形式发票金额为准，若不存在时，已收款金额为准)
      amountName() {
        return this.secondTotalAmount.originProformaInvoiceAmount
          ? 'originProformaInvoiceAmount'
          : 'originReceiveMoneyAmount';
      },
      // 所需计算的原币key
      needCalcOriginAmountProps() {
        let arr = [
          'originDomesticBankDeductFee',
          'originForeignBankDeductFee',
          'originReceiveMoneyAmount',
        ];
        /* if (this.amountName == 'originProformaInvoiceAmount') { // 形式发票金额
        arr = [
          'originReceiveMoneyAmount',
          ...arr,
        ];
      } */
        return arr;
      },
      isEdit() {
        if (
          (this.amountName == 'originProformaInvoiceAmount' &&
            !this.secondUnClaimAmount.originProformaInvoiceAmount) ||
          (this.amountName == 'originReceiveMoneyAmount' &&
            !this.secondUnClaimAmount.originReceiveMoneyAmount)
        ) {
          return false;
        } else {
          return true;
        }
      },
      rules() {
        return this.amountName == 'originProformaInvoiceAmount'
          ? {
              originProformaInvoiceAmount: [
                {
                  required: true,
                  message: this.$t(
                    'receivablesManage.placeholder.originProformaInvoiceAmountPlaceholder'
                  ),
                  trigger: ['blur', 'change'],
                },
              ],
            }
          : {
              originReceiveMoneyAmount: [
                {
                  required: true,
                  message: this.$t(
                    'receivablesManage.placeholder.originReceiveMoneyAmountPlaceholder'
                  ),
                  trigger: ['blur', 'change'],
                },
              ],
            };
      },
    },
    mounted() {
      this.getReceivedTypeOptions();
    },
    methods: {
      openDialog(flag, item) {
        // 打开
        this.dialogVisible = flag;
        this.query.isHNFlag = item.isHNFlag;
        this.query.businessType = item.businessType;
        this.query.registerId = item.registerId;
        this.query.firstClaimId = item.id;
        this.query.contractBusinessDepartment = item.claimDepartmentNo;
        this.query.contractBusinessDepartmentName = item.claimDepartmentName;
        this.query.contractCategory = item.customerNo ? 'sales' : 'purchase';
        this.query.customerNo = item.customerNo ? item.customerNo : item.claimPartnerNo;
        this.query.customerName = item.customerName ? item.customerName : item.claimPartnerName;
        this.query.receivedType = item.receivedType;
        this.currency = item.currency;
        this.secondTotalAmount = item.secondTotalAmount;
        this.getData();
      },
      getReceivedTypeOptions() {
        let options = this.$baseRequest.getDictListMapByType('receivedType');
        options.push({ label: '预收账款', value: 'RT17' });
        this.receivedTypeOptions = options;
      },
      closeDialog() {
        // 关闭
        this.dialogVisible = false;
        Object.keys(this.query).map((item) => {
          this.query[item] = null;
        });
        this.secondUnClaimAmount = {};
        this.tableData = [];
      },
      async getData() {
        // 获取合同信息
        this.load = true;
        let res = await this.$axios.post(API.QUERY_COLLECTIONCLAIM_CONTRACTFORSECOND, this.query);
        if (res) {
          this.load = false;
          if (res.data.code == 0) {
            if (res.data.data) {
              // 获取二次认领所选部门的未认领金额
              this.secondUnClaimAmount = res.data.data.unclaimedAmount;
              this.secondUnClaimAmount.claimedAmount =
                res.data.data.unclaimedAmount[this.amountName];
              // 获取合同
              this.tableData = res.data.data.fundCollectionContractClaims;
              this.tableData.map((item) => {
                item.registerId = this.query.registerId;
                item.contractBusinessDepartment = this.query.contractBusinessDepartment;
                item.contractBusinessDepartmentName = this.query.contractBusinessDepartmentName;
                item.receivedType = this.query.receivedType;
                Object.keys(this.rowObj).map((i) => {
                  // 不存在的key赋值
                  if (!item[i]) {
                    item[i] = this.rowObj[i];
                  }
                });
                //已认领金额（保证金+货款）=已认领合同保证金金额+已认领货款金额+本次认领保证金金额+本次认领货款金额，即为历史已认领货款&保证金金额+本次即将认领的保证金&货款金额
                item.claimedAmountTemp = [
                  item.receiveMarginAmount,
                  item.receiveGoodsAmount,
                  item.originReceiveMarginAmount,
                  item.originReceiveGoodsAmount,
                ].reduce((acc, cur) => {
                  const num = this.$cal.accAdd(acc, cur);
                  return this.$cal.calCommon(num, 0, '+', 'amount');
                }, 0);
                item[this.amountName] = item.claimedAmount = this.$cal.calCommon(
                  item.originReceiveMarginAmount,
                  item.originReceiveGoodsAmount,
                  '+',
                  'amount'
                );
                item.unClaimedAmountTemp = this.$cal.calCommon(
                  item.contractTotalAmount,
                  item.claimedAmountTemp,
                  '-',
                  'amount'
                );
                item.unClaimedAmount = this.$cal.calCommon(
                  item.contractTotalAmount,
                  item.claimedAmount,
                  '-',
                  'amount'
                );
              });
              this.autoCalc();
            } else {
              this.tableData = null;
            }
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      async save() {
        // 保存
        let contractClaims = await this.exportChildData();
        if (contractClaims) {
          if (this.flagUnClaimedAmount < 0) {
            return this.$message({
              showClose: true,
              message: this.$t('receivablesManage.message.calcInfo'),
              type: 'error',
            });
          }
          this.loading.startLoading();
          this.$axios
            .post(API.SAVE_COLLECTIONCLAIM_SECONDBYCONTRACT, {
              contractClaims,
              overAmountVerification: 'Y',
              firstClaimId: this.query.firstClaimId,
            })
            .then((res) => {
              this.loading.endLoading();
              if (res.data.code == 0) {
                this.$message({ showClose: true, type: 'success', message: res.data.msg });
                this.$emit('getAllData', this.query.registerId);
                this.closeDialog();
              } else {
                if (res.data.msg.indexOf('ERROR50001') != -1) {
                  this.$confirmAction(
                    res.data.msg.replace('ERROR50001', ''),
                    this.$t('receivablesManage.message.save')
                  )
                    .then(() => {
                      this.loading.startLoading();
                      this.$axios
                        .post(API.SAVE_COLLECTIONCLAIM_SECONDBYCONTRACT, {
                          contractClaims,
                          overAmountVerification: 'N',
                          firstClaimId: this.query.firstClaimId,
                        })
                        .then((res) => {
                          this.loading.endLoading();
                          if (res.data.code == 0) {
                            this.$message({
                              showClose: true,
                              type: 'success',
                              message: res.data.msg,
                            });
                            this.$emit('getAllData', this.query.registerId);
                            this.closeDialog();
                          } else {
                            this.$message({
                              showClose: true,
                              type: 'error',
                              message: res.data.msg,
                            });
                          }
                        });
                    })
                    .catch(() => {
                      this.$message({
                        showClose: true,
                        type: 'info',
                        message: this.$t('confirm.deleteCancelled'),
                      });
                    });
                } else {
                  this.$message({ showClose: true, type: 'error', message: res.data.msg });
                }
              }
            });
        }
      },
      // 在值发生改变时更新数据
      updateData() {
        let xTable = this.$refs.table;
        xTable.updateData();
      },
      // 表尾合计
      footerMethod({ columns }) {
        let hasChktableData = this.$refs.table.getCheckboxRecords();
        if (hasChktableData.length > 0) {
          let returnAmountProps = [
            'claimedAmount',
            'originProformaInvoiceAmount',
            'originReceiveMoneyAmount',
            'originDomesticBankDeductFee',
            'originForeignBankDeductFee',
          ];
          return [
            columns.map((column, columnIndex) => {
              if (columnIndex === 1) {
                return this.$t('receivablesManageDialog.secondClaim.hasClaim');
              }
              if (returnAmountProps.includes(column.property)) {
                let subtrahend = 0;
                for (let i = 0; i < hasChktableData.length; i++) {
                  subtrahend = this.$cal.calCommon(
                    hasChktableData[i][column.property],
                    subtrahend,
                    '+'
                  );
                }
                this.sumObj[column.property] = subtrahend;
                return this.$baseRequest.formatTableColumn(subtrahend);
              }
              return null;
            }),
            columns.map((column, columnIndex) => {
              if (columnIndex === 1) {
                return this.$t('receivablesManageDialog.secondClaim.noClaim');
              }
              if (returnAmountProps.includes(column.property)) {
                let minuend = this.secondUnClaimAmount[column.property];
                let subtrahend = 0;
                for (let i = 0; i < hasChktableData.length; i++) {
                  subtrahend = this.$cal.calCommon(
                    hasChktableData[i][column.property],
                    subtrahend,
                    '+'
                  );
                }
                if (column.property == this.amountName) {
                  this.flagUnClaimedAmount = this.$cal.calCommon(minuend, subtrahend, '-');
                }
                return this.$baseRequest.formatTableColumn(
                  this.$cal.calCommon(minuend, subtrahend, '-')
                );
              }
              return null;
            }),
          ];
        } else {
          return [];
        }
      },
      // 计算原币
      calcOriginAmount(amountRow, totalAmountRow, returnTotalAmount) {
        // 当前行标识金额 * 最终所需返回金额的总额 / 标识金额总额
        let calcAmount1 = this.$cal.calCommon(amountRow, returnTotalAmount, '*');
        let calcAmount2 = this.$cal.calCommon(calcAmount1, totalAmountRow, '/', 'amount');
        return calcAmount2;
      },
      // 自动计算金额
      autoCalc() {
        let idxs = [];
        // 自动勾选复选框数组
        let rowIdxArr = [];
        this.tableData.map((item, index) => {
          if (item.originReceiveMarginAmount > 0 || item.originReceiveGoodsAmount > 0) {
            idxs.push(index);
            rowIdxArr.push(this.tableData[index]);
          }
        });
        this.autoCalcOtherOrigin(idxs);
        this.setCheckboxRow(rowIdxArr);
        this.backOff();
        // 实时更新数据
        this.updateData();
        // 实时合计
        this.updateFooterEvent();
      },
      autoCalcOtherOrigin(idxs) {
        idxs.map((i) => {
          this.autoCalcOtherOriginItem(this.tableData[i]);
        });
      },
      // 自动计算每行其他原币金额
      autoCalcOtherOriginItem(row) {
        this.needCalcOriginAmountProps.map((i) => {
          row[i] = this.calcOriginAmount(
            row[this.amountName],
            this.secondTotalAmount[this.amountName],
            this.secondTotalAmount[i]
          );
        });
      },
      // 金额倒扣
      backOff() {
        this.$nextTick(() => {
          // 当合计金额等于总金额时，最后一条数据其他计算所得金额倒扣
          if (this.sumObj[this.amountName] == this.secondUnClaimAmount[this.amountName]) {
            let hasChktableData = this.$refs.table.getCheckboxRecords();
            let len = hasChktableData.length;
            if (len > 0) {
              this.needCalcOriginAmountProps.map((item) => {
                let itemAmount = hasChktableData[len - 1][item];
                let itemAmountSum = this.sumObj[item];
                hasChktableData[len - 1][item] = this.$cal.calCommon(
                  this.$cal.calCommon(this.secondUnClaimAmount[item], itemAmountSum, '-'),
                  itemAmount,
                  '+',
                  'amount'
                );
              });
            }
          }
          // 更新数据
          this.updateData();
        });
      },
      // 二次认领赋值
      chooseTable(val, row, prop) {
        row[prop] = val;
        if (['originReceiveMarginAmount', 'originReceiveGoodsAmount'].indexOf(prop) != -1) {
          row[this.amountName] = row.claimedAmount = this.$cal.calCommon(
            row.originReceiveMarginAmount,
            row.originReceiveGoodsAmount,
            '+',
            'amount'
          );
          row.unClaimedAmount = this.$cal.calCommon(
            row.contractTotalAmount,
            row.claimedAmount,
            '-',
            'amount'
          );
        }
        // 自动计算每行其他原币金额
        this.autoCalcOtherOriginItem(row);
        // 金额倒扣
        this.backOff();
        // 实时更新数据
        this.updateData();
        // 实时合计
        this.updateFooterEvent();
      },
      // 在值发生改变时更新表尾合计
      updateFooterEvent() {
        let xTable = this.$refs.table;
        xTable.updateFooter();
      },
      // 设置默认选中
      setCheckboxRow(rowIdxArr) {
        let xTable = this.$refs.table;
        xTable.setCheckboxRow(rowIdxArr, true);
      },
      // 选中事件
      handleSelectionChange() {
        this.updateFooterEvent();
      },
      // 重置
      resetBtnClick() {
        this.getData();
      },
      searchBtnClick() {
        if (!this.query.contractBusinessDepartment) {
          return this.tips('noSelDepart', 'error');
        }
        this.resetBtnClick();
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`receivablesManageDialog.message.${info}`),
          type: type,
        });
      },
      // 返回数据
      exportChildData() {
        let hasChktableData = [];
        this.$refs.table.getCheckboxRecords().map((item, index) => {
          hasChktableData.push({ ...item, sortNo: index });
        });
        // 点击提交，走校验
        if (hasChktableData.length == 0) {
          return [];
        } else {
          return new Promise((resolve) => {
            this.$refs.table.validate().then(() => {
              resolve(hasChktableData);
            });
          });
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  ::v-deep.secondClaimDialog {
    // text-align: center;
    .el-dialog__body {
      padding: 30px 100px 12px 100px;
      max-height: fit-content !important;
      .el-select,
      .el-input {
        width: 100%;
      }
    }
    .el-dialog__footer {
      text-align: center;
    }
  }
</style>
